import React from "react";
import { ImageIcon } from "lucide-react";
import { cn } from "@/lib/utils";

/** Placeholder when a POS product has no image. */
export default function PosProductPlaceholder({ className, code, compact = false }) {
  return (
    <div
      className={cn(
        "w-full h-full flex flex-col items-center justify-center bg-[#FFF3E8] text-brand-orange/35",
        compact ? "gap-0" : "gap-0.5",
        className,
      )}
      aria-hidden
    >
      <ImageIcon size={compact ? 16 : 22} strokeWidth={1.75} />
      {code && !compact ? (
        <span className="text-[8px] font-mono font-bold uppercase tracking-wide opacity-70">
          {String(code).slice(0, 6)}
        </span>
      ) : null}
    </div>
  );
}
